import { Lightning } from '@lightningjs/sdk';
import { templates } from './solo.constants';
import {
  HIDE_BACKGROUND_SIGNAL,
  IMPRESSION_TRACK_SIGNAL,
  IMPRESSION_UNTRACK_SIGNAL,
  SELECTED_SIGNAL,
  SHOW_BACKGROUND_SIGNAL,
} from '../../../signals';

export default class Solo extends Lightning.Component {
  static getOffsetsByBlockData(layoutData) {
    const { itemType } = layoutData || {};

    const bottom =
      itemType && typeof itemType.getBottomMargin === 'function' ? itemType.getBottomMargin(layoutData) : 0;

    return {
      top: 0,
      bottom: Number.isFinite(bottom) ? bottom : 0,
    };
  }

  _init() {
    this._contentPadding = 0;
    this._itemType = '';
  }

  _active() {
    if (Number.isFinite(this._blockIndex)) {
      this.signal(IMPRESSION_TRACK_SIGNAL, this._blockIndex, [0]);
    }
  }

  _inactive() {
    if (Number.isFinite(this._blockIndex)) {
      this.signal(IMPRESSION_UNTRACK_SIGNAL, this._blockIndex, [0]);
    }
  }

  _detach() {
    this._data = undefined;
  }

  get data() {
    return this._data;
  }

  set data(value) {
    this._data = value;
    const { block, blockIndex, itemSize, itemType, renderingContext } = this._data;
    const {
      content: { items: allItems },
    } = block;

    const items = allItems.slice(0, 1).map((item, itemIndex) => ({
      content: item,
      blockIndex,
      itemIndex,
      config: { ...itemSize },
      renderingContext,
    }));
    this._blockIndex = blockIndex;

    if (this.children.length === items.length) {
      for (let i = 0; i < items.length; i += 1) {
        this.children[i].item = items[i];
      }

      return;
    }

    this.patch({
      ...itemSize,
      children: items.map(item => ({
        ...itemSize,
        type: itemType,
        item,
        passSignals: {
          [SELECTED_SIGNAL]: true,
          [HIDE_BACKGROUND_SIGNAL]: true,
          [SHOW_BACKGROUND_SIGNAL]: true,
        },
      })),
    });
  }

  get contentPadding() {
    return this._contentPadding;
  }

  set contentPadding(value) {
    this._contentPadding = Number.isFinite(value) ? value : 0;
    if (this.children[0]) {
      this.children[0].contentPadding = this._contentPadding;
    }
  }

  _getFocused() {
    return this.children[0];
  }
}

Solo.Templates = { ...templates };
